module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-client-action-buttons"
  }, [_c('ModalReveal', [_c('button', {
    staticClass: "button warning",
    attrs: {
      "slot": "trigger",
      "type": "button"
    },
    slot: "trigger"
  }, [_vm._v("Edit")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Name"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.name),
      expression: "item.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "name", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Priority"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.priority),
      expression: "item.priority"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.priority)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "priority", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Group"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.group),
      expression: "item.group"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.item, "group", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("ALL")]), _c('option', [_vm._v("GENERAL")]), _c('option', [_vm._v("PLAN")])])])])]), _c('div', {
    staticClass: "row columns text-center"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Save Toc Type")])])]), _c('button', {
    staticClass: "button warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("Delete")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d3f0fdb!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/TocTypeButtons.vue
// module id = 2373
// module chunks = 1